import { useEffect, useState } from "react";
import { KeyRound, Save, X } from "lucide-react";
import { ActionButton } from "../design-system/ActionButton";
import { defaultModelSettings, loadModelSettings, saveModelSettings } from "../../logic/modelClient";
import type { ModelSettings } from "../../types/domain";

export function SettingsModal({
  open,
  onClose,
  onSaved
}: {
  open: boolean;
  onClose: () => void;
  onSaved: (settings: ModelSettings) => void;
}) {
  const [settings, setSettings] = useState<ModelSettings>(defaultModelSettings);

  useEffect(() => {
    if (open) {
      loadModelSettings().then(setSettings);
    }
  }, [open]);

  if (!open) return null;

  async function handleSave() {
    const saved = await saveModelSettings(settings);
    onSaved(saved);
    onClose();
  }

  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true">
      <section className="settings-modal">
        <button className="service-detail__close" onClick={onClose} aria-label="关闭设置">
          <X size={20} />
        </button>
        <div className="settings-modal__title">
          <KeyRound size={24} />
          <div>
            <h2>隐藏模型设置</h2>
            <p>Windows 或 Mac 桌面版可填 key 启用语义理解和真实文案；失败会自动回退本地规则。</p>
          </div>
        </div>
        <label className="settings-modal__toggle">
          <span>启用模型语义/文案</span>
          <input
            type="checkbox"
            checked={settings.modelEnabled}
            onChange={(event) => setSettings((current) => ({ ...current, modelEnabled: event.target.checked }))}
          />
        </label>
        <label>
          <span>API Key</span>
          <input
            type="password"
            value={settings.apiKey}
            onChange={(event) => setSettings((current) => ({ ...current, apiKey: event.target.value }))}
            placeholder="sk-..."
          />
        </label>
        <label>
          <span>Base URL</span>
          <input
            value={settings.baseUrl}
            onChange={(event) => setSettings((current) => ({ ...current, baseUrl: event.target.value }))}
          />
        </label>
        <label>
          <span>模型名</span>
          <input
            value={settings.model}
            onChange={(event) => setSettings((current) => ({ ...current, model: event.target.value }))}
          />
        </label>
        <div className="settings-modal__actions">
          <ActionButton icon={<Save size={16} />} variant="primary" onClick={handleSave}>保存</ActionButton>
        </div>
      </section>
    </div>
  );
}
